module.exports = __webpack_public_path__ + "static/media/simbarang.e8e57cbb.png";